import React from 'react';
import Lottie from 'react-lottie';
import './Added_To_Cart_Lottie.css';
import * as animationData from './Added_To_Cart_Lottie.json';

function Added_To_Cart_Lottie(){
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: animationData,
        rendererSettings: {
          preserveAspectRatio: "xMidYMid slice"
        }
      };
    
    return (
      <section className='main'>
            <div className='Added_To_Cart_Lottie_icon'>
                <Lottie className="me-auto"
                options={defaultOptions}
                // height={60}
                // width={60}          
                />       
        </div>
      </section>
    );
}
export default Added_To_Cart_Lottie;